module.exports = __webpack_public_path__ + "static/img/brees-2009-slide-6.5b1e44e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2009-slide-6.jpg
// module id = CyGK
// module chunks = 1